import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=39397fe5"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportModal.vue?vue&type=style&index=0&id=39397fe5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports